import { useCompanySettingsQuery } from 'common/hooks/useCompanySettings';
import Loader from 'components/Loader';

import CustomizationSection from './components/CustomizationSection';
import OptionsSection from './components/OptionsSection';
import { useInvoiceMinimumLateFeeQuery } from './hooks/useInvoiceMinimumLateFeeQuery';

const InvoicingInformation = () => {
  const { companySettings, loading: companySettingsLoading } =
    useCompanySettingsQuery();
  const { invoiceMinimumLateFee, loading: invoiceMinimumLateFeeLoading } =
    useInvoiceMinimumLateFeeQuery();

  if (companySettingsLoading || invoiceMinimumLateFeeLoading) {
    return <Loader />;
  }

  return (
    <>
      <CustomizationSection logoUrl={companySettings?.logoUrl} />
      <OptionsSection
        minLatePaymentFee={invoiceMinimumLateFee}
        settings={companySettings}
      />
    </>
  );
};

export default InvoicingInformation;
